const MEDIA_QUERY = {
  MD: 'only screen and (min-width : 768px)',
  XL: 'only screen and (min-width : 1024px)',
  SM: 'only screen and (max-width : 767px)',
};

export default MEDIA_QUERY;
